import script from "./informItemNotice.vue?vue&type=script&setup=true&lang=js"
export * from "./informItemNotice.vue?vue&type=script&setup=true&lang=js"

import "./informItemNotice.vue?vue&type=style&index=0&id=78d55c70&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src2302593107/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-78d55c70"]])

export default __exports__